import {
  createClient,
  DeleteOperation,
  deleteRequestFactory,
  FindOperation,
  getRequestFactory,
  postRequestFactory,
  putRequestFactory,
  SaveOperation,
  SearchOperation,
  searchRequestFactory
} from '@infuse/api/common';
import { Firmware, UpdateFirmwareApiCommand } from './model';

const client = createClient('/rest/operator-api/firmware');

export const firmwareManagementPermissions = {
  SEARCH: 'cpms.search-firmware',
  GET: 'cpms.get-firmware',
  UPLOAD: 'cpms.upload-firmware',
  UPDATE: 'cpms.update-firmware',
  DELETE: 'cpms.delete-firmware'
};

export const searchFirmware: SearchOperation<Firmware> = searchRequestFactory<Firmware>(client, {
  permissionId: firmwareManagementPermissions.SEARCH
});

export const getFirmware: FindOperation<Firmware, string> = getRequestFactory<Firmware, string>(client, {
  pattern: '/{firmwareId}',
  permissionId: firmwareManagementPermissions.GET
});

export const uploadFirmwareWithLocation: SaveOperation<FormData, string, never> = postRequestFactory<
  FormData,
  string,
  never
>(client, {
  pattern: '',
  permissionId: firmwareManagementPermissions.UPLOAD,
  returnLocation: true
});

export const updateFirmware: SaveOperation<UpdateFirmwareApiCommand, void, string> = putRequestFactory<
  UpdateFirmwareApiCommand,
  void,
  string
>(client, {
  pattern: '/{firmwareId}',
  permissionId: firmwareManagementPermissions.UPDATE
});

export const deleteFirmware: DeleteOperation<void, string> = deleteRequestFactory<void, string>(client, {
  pattern: '/{firmwareId}',
  permissionId: firmwareManagementPermissions.DELETE
});
